/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as InGameRouteImport } from './routes/in-game'
import { Route as PlayRouteImport } from './routes/play'
import { Route as SiteIndexRouteImport } from './routes/_site/index'
import { Route as SiteAboutRouteImport } from './routes/_site/about'
import { Route as SiteAccountRouteImport } from './routes/_site/account'
import { Route as SiteCampaignsRouteImport } from './routes/_site/campaigns'
import { Route as SiteFaqRouteImport } from './routes/_site/faq'
import { Route as SiteGameMastersRouteImport } from './routes/_site/game-masters'
import { Route as SiteHowItPlaysRouteImport } from './routes/_site/how-it-plays'
import { Route as SiteLegalRouteImport } from './routes/_site/legal'
import { Route as SitePlaytestRouteImport } from './routes/_site/playtest'
import { Route as SitePricingRouteImport } from './routes/_site/pricing'

const SiteRoute = SiteRouteImport.update({
  id: '/_site',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const InGameRoute = InGameRouteImport.update({
  id: '/in-game',
  path: '/in-game',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteIndexRoute = SiteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SiteRoute,
} as any)
const SiteAboutRoute = SiteAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => SiteRoute,
} as any)
const SiteAccountRoute = SiteAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SiteRoute,
} as any)
const SiteCampaignsRoute = SiteCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => SiteRoute,
} as any)
const SiteFaqRoute = SiteFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => SiteRoute,
} as any)
const SiteGameMastersRoute = SiteGameMastersRouteImport.update({
  id: '/game-masters',
  path: '/game-masters',
  getParentRoute: () => SiteRoute,
} as any)
const SiteHowItPlaysRoute = SiteHowItPlaysRouteImport.update({
  id: '/how-it-plays',
  path: '/how-it-plays',
  getParentRoute: () => SiteRoute,
} as any)
const SiteLegalRoute = SiteLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => SiteRoute,
} as any)
const SitePlaytestRoute = SitePlaytestRouteImport.update({
  id: '/playtest',
  path: '/playtest',
  getParentRoute: () => SiteRoute,
} as any)
const SitePricingRoute = SitePricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => SiteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof SiteIndexRoute
  '/admin': typeof AdminRoute
  '/in-game': typeof InGameRoute
  '/play': typeof PlayRoute
  '/about': typeof SiteAboutRoute
  '/account': typeof SiteAccountRoute
  '/campaigns': typeof SiteCampaignsRoute
  '/faq': typeof SiteFaqRoute
  '/game-masters': typeof SiteGameMastersRoute
  '/how-it-plays': typeof SiteHowItPlaysRoute
  '/legal': typeof SiteLegalRoute
  '/playtest': typeof SitePlaytestRoute
  '/pricing': typeof SitePricingRoute
}
export interface FileRoutesByTo {
  '/admin': typeof AdminRoute
  '/in-game': typeof InGameRoute
  '/play': typeof PlayRoute
  '/about': typeof SiteAboutRoute
  '/account': typeof SiteAccountRoute
  '/campaigns': typeof SiteCampaignsRoute
  '/faq': typeof SiteFaqRoute
  '/game-masters': typeof SiteGameMastersRoute
  '/how-it-plays': typeof SiteHowItPlaysRoute
  '/legal': typeof SiteLegalRoute
  '/playtest': typeof SitePlaytestRoute
  '/pricing': typeof SitePricingRoute
  '/': typeof SiteIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_site': typeof SiteRouteWithChildren
  '/admin': typeof AdminRoute
  '/in-game': typeof InGameRoute
  '/play': typeof PlayRoute
  '/_site/about': typeof SiteAboutRoute
  '/_site/account': typeof SiteAccountRoute
  '/_site/campaigns': typeof SiteCampaignsRoute
  '/_site/faq': typeof SiteFaqRoute
  '/_site/game-masters': typeof SiteGameMastersRoute
  '/_site/how-it-plays': typeof SiteHowItPlaysRoute
  '/_site/legal': typeof SiteLegalRoute
  '/_site/playtest': typeof SitePlaytestRoute
  '/_site/pricing': typeof SitePricingRoute
  '/_site/': typeof SiteIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/in-game'
    | '/play'
    | '/about'
    | '/account'
    | '/campaigns'
    | '/faq'
    | '/game-masters'
    | '/how-it-plays'
    | '/legal'
    | '/playtest'
    | '/pricing'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin'
    | '/in-game'
    | '/play'
    | '/about'
    | '/account'
    | '/campaigns'
    | '/faq'
    | '/game-masters'
    | '/how-it-plays'
    | '/legal'
    | '/playtest'
    | '/pricing'
    | '/'
  id:
    | '__root__'
    | '/_site'
    | '/admin'
    | '/in-game'
    | '/play'
    | '/_site/about'
    | '/_site/account'
    | '/_site/campaigns'
    | '/_site/faq'
    | '/_site/game-masters'
    | '/_site/how-it-plays'
    | '/_site/legal'
    | '/_site/playtest'
    | '/_site/pricing'
    | '/_site/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SiteRoute: typeof SiteRouteWithChildren
  AdminRoute: typeof AdminRoute
  InGameRoute: typeof InGameRoute
  PlayRoute: typeof PlayRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_site': {
      id: '/_site'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/in-game': {
      id: '/in-game'
      path: '/in-game'
      fullPath: '/in-game'
      preLoaderRoute: typeof InGameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_site/': {
      id: '/_site/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SiteIndexRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/about': {
      id: '/_site/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof SiteAboutRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/account': {
      id: '/_site/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof SiteAccountRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/campaigns': {
      id: '/_site/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof SiteCampaignsRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/faq': {
      id: '/_site/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof SiteFaqRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/game-masters': {
      id: '/_site/game-masters'
      path: '/game-masters'
      fullPath: '/game-masters'
      preLoaderRoute: typeof SiteGameMastersRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/how-it-plays': {
      id: '/_site/how-it-plays'
      path: '/how-it-plays'
      fullPath: '/how-it-plays'
      preLoaderRoute: typeof SiteHowItPlaysRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/legal': {
      id: '/_site/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof SiteLegalRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/playtest': {
      id: '/_site/playtest'
      path: '/playtest'
      fullPath: '/playtest'
      preLoaderRoute: typeof SitePlaytestRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/pricing': {
      id: '/_site/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof SitePricingRouteImport
      parentRoute: typeof SiteRoute
    }
  }
}

interface SiteRouteChildren {
  SiteAboutRoute: typeof SiteAboutRoute
  SiteAccountRoute: typeof SiteAccountRoute
  SiteCampaignsRoute: typeof SiteCampaignsRoute
  SiteFaqRoute: typeof SiteFaqRoute
  SiteGameMastersRoute: typeof SiteGameMastersRoute
  SiteHowItPlaysRoute: typeof SiteHowItPlaysRoute
  SiteLegalRoute: typeof SiteLegalRoute
  SitePlaytestRoute: typeof SitePlaytestRoute
  SitePricingRoute: typeof SitePricingRoute
  SiteIndexRoute: typeof SiteIndexRoute
}

const SiteRouteChildren: SiteRouteChildren = {
  SiteAboutRoute: SiteAboutRoute,
  SiteAccountRoute: SiteAccountRoute,
  SiteCampaignsRoute: SiteCampaignsRoute,
  SiteFaqRoute: SiteFaqRoute,
  SiteGameMastersRoute: SiteGameMastersRoute,
  SiteHowItPlaysRoute: SiteHowItPlaysRoute,
  SiteLegalRoute: SiteLegalRoute,
  SitePlaytestRoute: SitePlaytestRoute,
  SitePricingRoute: SitePricingRoute,
  SiteIndexRoute: SiteIndexRoute,
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SiteRoute: SiteRouteWithChildren,
  AdminRoute: AdminRoute,
  InGameRoute: InGameRoute,
  PlayRoute: PlayRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
